/**
 * Short-lived in-memory search context for find-page analytics.
 * Used when the user selects a location from the header autocomplete while already on /find:
 * we need to report search_context=header without adding it to the URL.
 */
const findSearchContext = ref<'header' | undefined>(undefined);

export function useFindSearchContext() {
  function setFindSearchContext(context: 'header' | undefined) {
    findSearchContext.value = context;
  }

  function getAndClearFindSearchContext(): 'header' | undefined {
    const value = findSearchContext.value;
    findSearchContext.value = undefined;
    return value;
  }

  return {
    setFindSearchContext,
    getAndClearFindSearchContext,
  };
}
